module.exports = __webpack_public_path__ + "static/media/Party.30f11d6b.svg";